var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "location-breadcrumb" },
    [
      _c("h5", { staticClass: "section-title" }, [
        _vm._v("📁 Ubicación de Guardado")
      ]),
      _c("b-card", { staticClass: "location-card" }, [
        _c(
          "div",
          { staticClass: "breadcrumb-path" },
          _vm._l(_vm.location.breadcrumb, function(item, index) {
            return _c("span", { key: index, staticClass: "breadcrumb-item" }, [
              _vm._v(" " + _vm._s(item) + " "),
              index < _vm.location.breadcrumb.length - 1
                ? _c(
                    "span",
                    { staticClass: "separator" },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "ChevronRightIcon", size: "14" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }